export const fieldValidations = {
  sender: [
    {
      field: "firstName",
      label: "first_name",
      regexChars: /^[\p{L}\s"'’-]+$/u, // Letters only
      regexSapces: /^(?!\s)(?!.* {2,})(?!.*\s$)(.+( .+)*)?$/u, // No spaces
      minLength: 2, // Minimum length requirement
    },
    {
      field: "lastName",
      label: "last_name",
      regexChars: /^[\p{L}\s"'’-]+$/u, // Letters only
      regexSapces: /^(?!\s)(?!.* {2,})(?!.*\s$)(.+( .+)*)?$/u, // No spaces
      minLength: 2, // Minimum length requirement
    },
    {
      field: "city",
      label: "city",
    },
    {
      field: "street",
      label: "street",
    },
    {
      field: "buildingNum",
      label: "building_num",
      regexChars: /^\d+$/, // Numeric only
      regexPrefix: /^(?!0)/, // No leading zeros
    },
    {
      field: "ApartmentNum",
      label: "apartment_num",
      required: false,
      regexChars: /^\d+$/,
      regexPrefix: /^(?!0)/, // No leading zeros
    },
    { field: "zip", label: "zip", required: false, regexChars: /^\d+$/ },
    {
      field: "phoneNumber",
      label: "phone_number",
      regexChars: /^\d+$/, // Numeric only
      regexPrefix: /^(?!0)/, // No leading zeros
      minLength: 7, // Minimum length requirement
      maxLength: 7, // Maximum length requirement
    },
    {
      field: "areaCode",
      label: "area_code",
    },
  ],
  receiver: [
    {
      field: "firstName",
      label: "first_name",
      regexChars: /^[\p{L}\s"'’-]+$/u, // Letters only
      regexSapces: /^(?!\s)(?!.* {2,})(?!.*\s$)(.+( .+)*)?$/u, // No spaces
      minLength: 2, // Minimum length requirement
    },
    {
      field: "lastName",
      label: "last_name",
      regexChars: /^[\p{L}\s"'’-]+$/u, // Letters only
      regexSapces: /^(?!\s)(?!.* {2,})(?!.*\s$)(.+( .+)*)?$/u, // No spaces
      minLength: 2, // Minimum length requirement
    },
    {
      field: "city",
      label: "city",
    },
    {
      field: "street",
      label: "street",
    },
    {
      field: "buildingNum",
      label: "building_num",
      regexChars: /^\d+$/, // Numeric only
      regexPrefix: /^(?!0)/, // No leading zeros
    },
    {
      field: "ApartmentNum",
      label: "apartment_num",
      required: false,
      regexChars: /^\d+$/,
      regexPrefix: /^(?!0)/, // No leading zeros
    },
    { field: "zip", label: "zip", required: false, regexChars: /^\d+$/ },
    {
      field: "phoneNumber",
      label: "phone_number",
      regexChars: /^\d+$/, // Numeric only
      regexPrefix: /^(?!0)/, // No leading zeros
      minLength: 7, // Minimum length requirement
      maxLength: 7, // Maximum length requirement
    },
    {
      field: "areaCode",
      label: "area_code",
    },
  ],
  business: [
    {
      field: "company",
      label: "company",
      // regexChars: /^[\p{L}\s]+$/u, // Letters only
      regexSapces: /^(?!\s)(?!.* {2,})(?!.*\s$)(.+( .+)*)?$/u, // No spaces
      minLength: 2, // Minimum length requirement
    },
    {
      field: "companyId",
      label: "company_id",
      regexSapces: /^(?!\s)(?!.* {2,})(?!.*\s$)(.+( .+)*)?$/u, // No spaces
      //regexChars: /^\d+$/, // Numeric only
      //regexPrefix: /^(?!0)/, // No leading zeros
      //minLength: 7, // Minimum length requirement
      //maxLength: 7, // Maximum length requirement
    },
    { field: "city", label: "city" },
    { field: "street", label: "street" },
  ],
  collectionBucket: [
    {
      field: "phoneNumber",
      label: "phone_number",
      regexChars: /^\d+$/, // Numeric only
      regexPrefix: /^(?!0)/, // No leading zeros
      minLength: 7, // Minimum length requirement
      maxLength: 7, // Maximum length requirement
    },
    {
      field: "areaCode",
      label: "area_code",
    },
  ],
};
